<template>
  <div>
    <div class="fund-page">
      <vs-card>
        <FundCard class="mb-6 md:mb-8" v-bind:availableBalance="availableBalance"></FundCard>
        <vs-divider></vs-divider>
        <div class="p-6 md:p-8">
          <div class="add-fund-title w-full md:add-fund-title">
            Add Funds
          </div>
          <span class="fund-description-span" v-if="!$store.getters['authentication/activeAccount'].verified_at">
            You can add up to $1,000 to your balance until you fill in your Verification Section.
          </span>
          <div class="flex flex-wrap w-full md:flex-no-wrap payments-div">
            <!-- Add Fund Card -->
            <AddFundCard
              v-on:paymentMethodSelected="handlePaymentMethodChange"
              v-on:amount-change="handleAmountChange"
              :total="amount"
              :disablePayButton="showPopup"
              :paymentMethod="paymentMethod"
              class="w-full mb-8 md:mb-0 md:w-2/3 md:mr-6"
            ></AddFundCard>

            <FundSummaryCard
              v-if="paymentMethodSelected"
              class="w-full lg:w-1/3"
              :paymentMethod="paymentMethod"
              :amount="amount"
              :isAdmin="false"
            ></FundSummaryCard>
          </div>
        </div>
      </vs-card>

      <vs-card class="mt-4 py-6 md:px-8 md:mt-8">
        <!-- Transaction Table -->
        <vs-tabs>
          <vs-tab label="Transactions"> </vs-tab>
        </vs-tabs>
        <Transaction />
      </vs-card>

      <speakol-confirmation-popup v-on:hide-confirmation-popup="setDefaults" :showConfirmationPopup="showPopup" :title="'Account Address'" confirmationText="Save and Fund" cancelText="Back Home" v-on:confirm="updateAccountData">
        <template v-slot:body>
          <UpdateAddress ref="account-data" v-on:account-updated="showPopup = false" />
        </template>
      </speakol-confirmation-popup>
    </div>
  </div>
</template>

<script>
import FundCard from './components/FundCard.vue'
import Transaction from './components/AdvertiserTransactions/index'
import OrderSummary from './components/OrderSummary.vue'
import AddFundCard from './components/AddFundCard.vue'
import UpdateAddress from './components/UpdateAddress.vue'
import FundSummaryCard from '../admin/components/FundSummaryCard.vue'
import {get} from 'lodash'

export default {
  data () {
    return {
      paymentMethodSelected: false,
      isPaymentDisabled : false,
      showPopup: false,
      amount: null,
      paymentMethod: null
    }
  },
  components: {
    FundCard,
    Transaction,
    OrderSummary,
    AddFundCard,
    UpdateAddress,
    FundSummaryCard
  },
  computed: {
    account () {
      return this.$store.getters['authentication/activeAccount']
    },
    availableBalance () {
      return this.$store.getters['fund/balance'].balance
    }
  },
  mounted () {
    this.$store.dispatch('fund/getBalance')

    const country = get(
      this.$store.getters['authentication/activeAccount'],
      'country',
      false
    )
    if (!country) {
      this.showMissingAccountDataPopup()
    }
  },
  methods: {
    showMissingAccountDataPopup () {
      this.showPopup = true
    },
    setDefaults () {
      this.showPopup = false
      setTimeout(() => {
        this.$router.push('/')
      }, 500)
    },
    handleAmountChange (amount) {
      this.amount = amount
    },

    handlePaymentMethodChange (paymentMethod) {
      this.paymentMethodSelected = true
      if (paymentMethod === 'creditCard') {
        // if user hasFeature stripe and !hasFeature paytabs
        // if user hasFeature stripe and hasFeature paytabs
        //    use stripe
        // if user hasFeature paytabs and !hasFeature stripe
        //    use paytabs
        if (this.$hasFeature('stripe')) {
          this.paymentMethod = this.$constants.PAYMENT_METHODS.STRIPE
        } else if (this.$hasFeature('paytabs')) {
          this.paymentMethod = this.$constants.PAYMENT_METHODS.PAYTABS
        } else if (this.$hasFeature('checkout')) {
          this.paymentMethod = this.$constants.PAYMENT_METHODS.CHECKOUT
        }
      } else {
        this.paymentMethod = this.$constants.PAYMENT_METHODS.PAYPAL
      }
    },

    async updateAccountData () {
      await this.$refs['account-data'].submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.payments-div {
  margin-top: 25px;
}

.strong-underline {
  text-decoration: underline;
}

.fund-description-span {
  width: 564px;
  height: 21px;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  align-items: center;
  color: #0092d7;
}

.fund-page {
  /deep/ .vs-tabs--li {
    margin-left: 20px;
    margin-right: 30px;
  }
}

.add-fund-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.hide {
  display: none !important;
}

@media (min-width: 768px) {
  .md\:add-fund-title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px !important;
    line-height: 36px;

    /* identical to box height */

    letter-spacing: 0.1px;
    color: #2c2c2c;
  }
}
</style>
